/**
 * Created by asiulik on 29.11.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', './filterConfig', '../../utils'], function($, _, EventEmitter, FilterConfig, Utils){

    var filterContentConfig = {
        buttonSelector: ".loadmore__button",
        visibilityStep: 10
    };

    function FilterContent($element){
        this.$element = $element;
    }

    FilterContent.prototype = _.clone(EventEmitter.prototype);

    FilterContent.prototype.init = function () {

        this.$visibilityItemsStep = $(filterContentConfig.buttonSelector).data('filter-more') || filterContentConfig.visibilityStep;

        this.$filterItems = this.$element.find(FilterConfig.filterElementSelector);

        this.displayElementsCount = this.getDisplayElementsCount(
            this.$filterItems,
            FilterConfig.filterElementVisibleClass
        );

        if(this.displayElementsCount >= this.$filterItems.length) {
            this.emit('filter:content:allVisible');
        }

    };

    FilterContent.prototype.displayContentByCurrentTag = function(tag){

        this.$elements = this.getFilterElementsByTag(this.$filterItems, tag);

        this.$filterItems.addClass(FilterConfig.filterElementHiddenClass);
        this.$elements.removeClass(FilterConfig.filterElementHiddenClass);

        this.emit('filter:content:contentChanged', this.$elements);

    };

    FilterContent.prototype.getFilterElementsByTag = function(itemsCollection, tagName) {

        return itemsCollection.filter(function(index, item) {
            return tagName ? this.checkElementContainTag($(item), tagName) : !tagName;
        }.bind(this));

    };

    FilterContent.prototype.checkElementContainTag = function($item, tagName){

        var tagsString = $item.attr(FilterConfig.filterElementTagAttr);
        var tagsAtt = tagsString.split(',');

        return tagsAtt.indexOf(tagName) >= 0;

    };

    FilterContent.prototype.replaceContentWithAnimation = function($content){

        this.$element.html($content.html());
        this.init();

        this.emit('filter:content:contentChanged', this.$element);

    };

    FilterContent.prototype.showMoreContent = function(){

        var elementsShouldBeVisible = this.$filterItems.slice(0, this.displayElementsCount + this.$visibilityItemsStep);

        elementsShouldBeVisible.addClass(FilterConfig.filterElementVisibleClass);

        Utils.scrollPositionAnimate(
            elementsShouldBeVisible.eq(this.displayElementsCount - 2).offset().top
        );

        this.displayElementsCount = this.getDisplayElementsCount(
            this.$filterItems,
            FilterConfig.filterElementVisibleClass
        );

        if(this.displayElementsCount == this.$filterItems.length) {
            this.emit('filter:content:allVisible');
        }

    };

    FilterContent.prototype.getDisplayElementsCount = function(collection, className){
        return collection.filter(function(index, item){
            return $(item).hasClass(className)
        }).length
    };

    return FilterContent;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/filters/filterContent.js